import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionProcessingPage.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginApi } from '../Http/http';
import Cookies from "js-cookie";
import waitAnimation from "../animations/waitAnimation.json";
import Lottie from 'lottie-react';

const SubscriptionProcessingPage = () => {

    const location = useLocation();
    const [msisdn, setMsisdn] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [attemptCount, setAttemptCount] = useState(0);

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
        }
        else {
            // navigate("/");
        }
    }, [location]);

    useEffect(() => {
        let apiInterval = null;

        if (!loading && msisdn && attemptCount < 100) {
            apiInterval = setInterval(() => {
                handleFormSubmission();
            }, 2000);
        }

        if (attemptCount > 100) {
            toast.error("Something Went Wrong!");
            navigate("/login");
        }

        return () => {
            if (apiInterval) {
                clearInterval(apiInterval);
            }
        };
    }, [msisdn, attemptCount, loading]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);
            await loginApi(msisdn)
                .then((res) => {
                    setLoading(false);
                    console.log("res---", res?.data?.result?.msisdn);
                    Cookies.set("msisdn", msisdn, {
                        expires: 1
                    })
                    navigate("/home");
                    toast.success("Subscribed Successfully! Login...");
                })
                .catch((err) => {
                    setLoading(false);
                    setAttemptCount(prev => prev + 1);
                });
        } catch (error) {
            setLoading(false);
            setAttemptCount(prev => prev + 1);
            console.log(error, 'error--');
        }
    }

    return (
        <main className={classes.main}>
            <div className={classes.container}>
                <h1 className={classes.portalDescription}>Games Dal</h1>

                <div className={classes.container_2}>
                    <div className={classes.description}>
                        <h2 className={classes.title}>Subscription In Process</h2>
                        <ul className={classes.list}>
                            <li className={classes.text}>
                                Dear User, your subscription is in process!
                            </li>
                        </ul>

                        <div className={classes.animation_container}>
                            <Lottie animationData={waitAnimation} loop autoPlay className={classes.animation} />
                        </div>

                        <p className={classes.text2}>
                            You will be auto redirected when successfully subscribed!
                        </p>
                    </div>
                </div>


            </div>
        </main>
    )
}

export default SubscriptionProcessingPage